import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 27"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M13 .25c-7.21 0-13 5.84-13 13 0 7.21 5.79 13 13 13 7.16 0 13-5.79 13-13 0-7.16-5.84-13-13-13m0 6.5c1.98 0 3.656 1.676 3.656 3.656 0 2.031-1.675 3.656-3.656 3.656a3.64 3.64 0 0 1-3.656-3.656c0-1.98 1.625-3.656 3.656-3.656M13 23a9.7 9.7 0 0 1-6.906-2.844c.812-2.133 2.843-3.656 5.281-3.656h3.25c2.387 0 4.418 1.523 5.23 3.656A9.68 9.68 0 0 1 13 23"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }